/*** Created by Ella Ma on 02 / 09 / 2021.
  * Description:
*
* ------maintenance history------
* 9 / 23 / 2021 Simon Zhao added a property for notification setting.
*
**/

import { AbstractControl, ValidationErrors } from '@angular/forms';
import { UntypedFormGroup, ValidatorFn } from '@angular/forms';

export class PostActionConfig {
    checkCreateRelationship: boolean;
    checkCreateNote: boolean;
    checkEntity: boolean;
    checkUpdateMetadata: boolean;
    configChanged = false;
    isImport = false;
    isNotificationOn = false;
    notificationValidationFrmGroup: UntypedFormGroup = new UntypedFormGroup({});
    constructor() {
        this.checkCreateRelationship = false;
    }
}

export enum ParticipantType {
    user = 'user',
    team = 'team'
}

export enum PostNotificationFieldEnum {
    fixedReceivers = 'fixedReceivers',
    email = 'email',
    inApp = 'inApp'
}

/**
 * offer the capabilities of validate form data by each validator function
 *
 * @export
 * @class CustomValidators
 */
export class CustomValidators {
    /**
     * a group required validator which would raise an error if all of group memebers are empty, otherwise, the validation passes.
     *
     * @static
     * @param {*} memberKeys the form control key array, each of which is the name of one form control accosicated to the same group.
     * @return {*}  {ValidatorFn}
     * @memberof CustomValidators
     */
    static groupBooleanRequired(...memberKeys): ValidatorFn {
        const validateFunc = (frmGroup: UntypedFormGroup): ValidationErrors | null => {
            const firstCtrl = frmGroup.get(memberKeys[0]);
            for (let i = 0; i < memberKeys.length; i++) {
                if (frmGroup.contains(memberKeys[i]) && frmGroup.controls[memberKeys[i]].value === true) {
                    firstCtrl.setErrors(null);
                    return;
                }
            }

            const errorObj = {};
            errorObj[memberKeys[0]] = true;
            firstCtrl.setErrors(errorObj);
            return;
        };

        return validateFunc;
    }
}
